import { Controller } from "@hotwired/stimulus"

// This controller is used to show and hide the sidepanel on the leads list page, the open and close functions
// are triggered using stimulus actions.
export default class extends Controller {
  static get targets() {
    return ["sidePanel"]
  }

  open() {
    this.sidePanelTarget.setAttribute("aria-hidden", "false")
  }

  close() {
    this.sidePanelTarget.setAttribute("aria-hidden", "true")
  }
}
